import { apiCall } from 'store/services/service';
import { URL_ARTICLE_DETAIL } from 'store/services/URL';
import { ArticleDetail } from 'views/articles/articleTypes';

/** Fetch a single article: GET /articles/<id> */
export async function fetchArticleById(id: number): Promise<ArticleDetail | null> {
  const res: any = await apiCall.get({
    url: `${URL_ARTICLE_DETAIL}${id}`,
    isAuthToken: true,
    params: {},
  });

  if (res && res.id) {
    return res as ArticleDetail;
  }
  return null;
}
